import React,{useState, useEffect} from 'react';
import { useQuery } from '@apollo/client';
import { LOAD_NEWSFEED } from '../graphql/queries.js';


export default function useItemsList(categories){
    let ismount = true
    const [newsitems,setNewsitems] = useState({});
    const [items,setItems] = useState({})
    const [prevcat,setPrevcat] = useState("");
    const {error, loading, data, fetchMore} = useQuery(LOAD_NEWSFEED, {categories});
  
    
    
    const updateQuery =  ( previousResult  , { fetchMoreResult } ) => {
        if(categories.variables.categoryName == prevcat){
           
           fetchMoreResult.posts.edges = [...new Set([...previousResult.posts.edges, ...fetchMoreResult.posts.edges])];
            return fetchMoreResult;
        }else{
            setPrevcat(categories.variables.categoryName);
            return fetchMoreResult;
        }
        

      };

      const newQuery = (previousResult, {fetchNewResult}) =>{

        //alert("ok")
        //return fetchNewResult;
      }
      
      
    useEffect(()=>{

        if(data){

            //console.log(data.posts.edges)
            setNewsitems(data.posts.pageInfo);
            setItems(data.posts.edges);
            //console.log(data.posts.edges)
            //setLoading(false)
            }
    },[data]);    


    /*useEffect(() => {
        if(data){

            //console.log(data)
        }
        setLoading(true)
        setError(false)
        let cancel

        axios({
            method: 'GET',
            url: 'https://www.myjoyonline.com/wp-json/mjo/v1/lateststories/',
            params:{
            page:page,
            order_by:"date",
            sort:"desc",
            status:"publish",
            category: categories},

            cancelToken: new axios.CancelToken(c => cancel = c)
        }).then(res =>{
            if(ismount){
            setNewsitems(prevNewsitems => {return prevNewsitems, res.data});
            setLoading(false)
            }
        }).catch(e => {
            if(axios.isCancel(e)){

                console.log("Error loading data from api")
            } 
            
            console.log(e)
            setError(true) 
            setLoading(false)
            console.log("error loading api")
        })

    },[ page, categories ]);*/



    
return { newsitems, error, loading, items, fetchMore, updateQuery, newQuery }
}